var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCross = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01164 0.637688C2.32285 -0.0511045 1.20609 -0.0511044 0.517301 0.637688C-0.171492 1.32648 -0.171492 2.44324 0.5173 3.13203L5.50626 8.12098L0.517083 13.1102C-0.17171 13.799 -0.17171 14.9157 0.517083 15.6045C1.20588 16.2933 2.32263 16.2933 3.01142 15.6045L8.0006 10.6153L12.989 15.6037C13.6778 16.2925 14.7945 16.2925 15.4833 15.6037C16.1721 14.9149 16.1721 13.7982 15.4833 13.1094L10.4949 8.12099L15.4831 3.1328C16.1719 2.444 16.1719 1.32725 15.4831 0.638457C14.7943 -0.0503359 13.6776 -0.0503347 12.9888 0.638458L8.0006 5.62664L3.01164 0.637688Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01164 0.637688C2.32285 -0.0511045 1.20609 -0.0511044 0.517301 0.637688C-0.171492 1.32648 -0.171492 2.44324 0.5173 3.13203L5.50626 8.12098L0.517083 13.1102C-0.17171 13.799 -0.17171 14.9157 0.517083 15.6045C1.20588 16.2933 2.32263 16.2933 3.01142 15.6045L8.0006 10.6153L12.989 15.6037C13.6778 16.2925 14.7945 16.2925 15.4833 15.6037C16.1721 14.9149 16.1721 13.7982 15.4833 13.1094L10.4949 8.12099L15.4831 3.1328C16.1719 2.444 16.1719 1.32725 15.4831 0.638457C14.7943 -0.0503359 13.6776 -0.0503347 12.9888 0.638458L8.0006 5.62664L3.01164 0.637688Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross.95f73aac251be0aba39d9468ae784370.svg";